export default __webpack_public_path__ + "img/bg-tab1and2_nav11-ed0069a7.png";